import { ChakraProvider } from '@chakra-ui/react'
import { RecoilRoot, useRecoilSnapshot } from 'recoil'

import * as React from 'react'

import { LayoutContext, initialLayoutState, layoutReducer } from '../context/LayoutContext'
import { theme } from '../styles/theme'
import LayoutContent from './LayoutContent'

function DebugObserver(): React.Node {
  const snapshot = useRecoilSnapshot()
  React.useEffect(() => {
    console.debug('The following atoms were modified:')
    for (const node of snapshot.getNodes_UNSTABLE({ isModified: true })) {
      console.debug(node.key, snapshot.getLoadable(node))
    }
  }, [snapshot])

  return null
}

type Props = {
  children: React.ReactNode
}

const Layout: React.FC<Props> = ({ children }) => {
  const [layoutState, dispatchLayoutAction] = React.useReducer(layoutReducer, initialLayoutState)
  return (
    <RecoilRoot>
      <DebugObserver />
      <ChakraProvider resetCSS={true} theme={theme}>
        <LayoutContext.Provider value={{ layoutState, dispatchLayoutAction }}>
          <LayoutContent>{children}</LayoutContent>
        </LayoutContext.Provider>
      </ChakraProvider>
    </RecoilRoot>
  )
}

export default Layout
